import React from "react";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";

// Enrichment fields used by the create wizard (step 1). The edit workspace
// has its own Details tab. Keep this presentation-only.

export const ProductEnrichmentFields = ({
  t,
  value,
  onChange,
  showDetailSections = false,
  onDetailSectionChange,
  onAddDetailSection,
  onRemoveDetailSection,
}) => (
  <>
    <Row>
      <Col md="7">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentProductStory")}</Label>
          <Input
            type="textarea"
            rows="4"
            value={value.productStory}
            onChange={(event) => onChange("productStory", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentProductStoryPlaceholder")}
          />
          <small className="catalog-admin-field-hint">
            {t("catalogProductStudio.enrichmentProductStoryHint")}
          </small>
        </FormGroup>
      </Col>
      <Col md="5">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentDetailChips")}</Label>
          <Input
            type="textarea"
            rows="4"
            value={value.badgesText}
            onChange={(event) => onChange("badgesText", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentDetailChipsPlaceholder")}
          />
          <small className="catalog-admin-field-hint">
            {t("catalogProductStudio.enrichmentDetailChipsHint")}
          </small>
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col md="6">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentMaterial")}</Label>
          <Input
            value={value.material}
            onChange={(event) => onChange("material", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentMaterialPlaceholder")}
          />
        </FormGroup>
      </Col>
      <Col md="6">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentComposition")}</Label>
          <Input
            value={value.composition}
            onChange={(event) => onChange("composition", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentCompositionPlaceholder")}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col md="6">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentCare")}</Label>
          <Input
            type="textarea"
            rows="3"
            value={value.careInstructions}
            onChange={(event) => onChange("careInstructions", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentCarePlaceholder")}
          />
        </FormGroup>
      </Col>
      <Col md="6">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentHighlights")}</Label>
          <Input
            type="textarea"
            rows="3"
            value={value.highlightsText}
            onChange={(event) => onChange("highlightsText", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentHighlightsPlaceholder")}
          />
          <small className="catalog-admin-field-hint">
            {t("catalogProductStudio.enrichmentHighlightsHint")}
          </small>
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col md="6">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentFitNotes")}</Label>
          <Input
            type="textarea"
            rows="3"
            value={value.fitNotes}
            onChange={(event) => onChange("fitNotes", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentFitPlaceholder")}
          />
        </FormGroup>
      </Col>
      <Col md="6">
        <FormGroup>
          <Label>{t("catalogProductStudio.enrichmentSizeGuide")}</Label>
          <Input
            type="textarea"
            rows="3"
            value={value.sizeGuideNotes}
            onChange={(event) => onChange("sizeGuideNotes", event.target.value)}
            placeholder={t("catalogProductStudio.enrichmentSizeGuidePlaceholder")}
          />
        </FormGroup>
      </Col>
    </Row>
    <FormGroup>
      <Label>{t("catalogProductStudio.enrichmentStyling")}</Label>
      <Input
        type="textarea"
        rows="3"
        value={value.stylingNotes}
        onChange={(event) => onChange("stylingNotes", event.target.value)}
        placeholder={t("catalogProductStudio.enrichmentStylingPlaceholder")}
      />
    </FormGroup>

    {showDetailSections ? (
      <div className="catalog-studio-subsection">
        <div className="catalog-simple-field-header">
          <div>
            <Label>{t("catalogProductStudio.enrichmentDetailSections")}</Label>
          </div>
          <Button color="secondary" outline size="sm" onClick={onAddDetailSection}>
            {t("catalogProductStudio.enrichmentAddSection")}
          </Button>
        </div>
        {(value.detailSections || []).length ? (
          value.detailSections.map((section, index) => (
            <div key={`detail-section-${index}`} className="catalog-studio-manual-row">
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label>{t("catalogProductStudio.enrichmentSectionTitle")}</Label>
                    <Input
                      value={section.title}
                      onChange={(event) =>
                        onDetailSectionChange(index, "title", event.target.value)
                      }
                      placeholder={t("catalogProductStudio.enrichmentSectionTitlePlaceholder")}
                    />
                  </FormGroup>
                </Col>
                <Col md="7">
                  <FormGroup>
                    <Label>{t("catalogProductStudio.enrichmentSectionCopy")}</Label>
                    <Input
                      type="textarea"
                      rows="2"
                      value={section.body}
                      onChange={(event) =>
                        onDetailSectionChange(index, "body", event.target.value)
                      }
                      placeholder={t("catalogProductStudio.enrichmentSectionCopyPlaceholder")}
                    />
                  </FormGroup>
                </Col>
                <Col md="1" className="d-flex align-items-end">
                  <Button
                    color="link"
                    className="catalog-studio-remove-button mb-3"
                    onClick={() => onRemoveDetailSection(index)}
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
            </div>
          ))
        ) : (
          <p className="catalog-simple-inline-hint">
            {t("catalogProductStudio.enrichmentNoDetailSections")}
          </p>
        )}
      </div>
    ) : null}
  </>
);
